import * as React from 'react';
import './completeCheck.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';

type Props = {
    onCompleteClick: () => any;
};

export class CompleteCheck extends React.Component<Props> {
    render() {
        const { onCompleteClick } = this.props;
        return (
            <div styleName="understanding-check">
                <div styleName="text">
                    お疲れ様でした！<br />これでこのコースは終了です。
                </div>
                <div styleName="button-wrapper">
                    <Button styleName="button" type="primary" size="m" onClick={onCompleteClick}>
                        戻る
                    </Button>
                </div>
            </div>
        );
    }
}
